import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {URL_NEWS_CREATE, URL_VICTIM_STATUS_CREATE, URL_VICTIM_TYPE_CREATE} from "../../../mock/page_urls";
import {useQuery} from "react-query";
import {getVictims, getVictimStatuses} from "../../../services/victimSvc";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {separateFormatter} from "../../../utils/separateFormatter";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import phoneFormatter from "../../../utils/phoneFormatter";
import {MyTooltip} from "../../../components/common/tooltip/Tooltip";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_VICTIM} from "../../../mock/URLs";

export const VictimsPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);

  const {
    data: victimData,
    isLoading: victimIsLoading,
    refetch: refetchVictim
  } = useQuery(["getVictims", page, debouncedSearch], () => getVictims({
    params: {
      page_size: 8,
      page,
      search: debouncedSearch
    }
  }), {
    keepPreviousData: true,
  })

  const pageDetails = {
    title: "Viktimlik arizalari",
    desc: `Jami arizalar soni: (${separateFormatter(victimData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(URL_VICTIM_TYPE_CREATE),
      text: "Tur qo'shish",
      icon: "plus-square",
      className: "btn-light-primary"
    },
      {
        onClick: () => navigate(URL_VICTIM_STATUS_CREATE),
        text: "Holat qo'shish",
        icon: "plus-square",
        className: "btn-light-primary"
      }]
  };

  const totalItems = victimData?.total_items || 0;
  const itemsPerPage = victimData?.page_size || 8;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchVictim();
    }
  }, [debouncedSearch, refetchVictim]);


  const {openDeleteModal} = useDeleteModal()
  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_VICTIM, id, refetchVictim);
  };

  return (
      <div>
        <div className="">
          <PageHeader pageDetails={pageDetails}/>
          <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
            <div className={"w-100 w-100 w-md-250px"}>
              <div className="d-flex align-items-center position-relative my-1">
                <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>

                <input type="text" data-kt-user-table-filter="search"
                       className="form-control w-100 w-md-250px ps-12"
                       placeholder="Qidiruv..." value={searchQuery}
                       onChange={handleSearchChange}/>
              </div>
            </div>
          </div>

          {victimIsLoading ? (
              <LoaderSection height={"50vh"}/>
          ) : !victimData || victimData?.data?.length === 0 ? (
              <EmptySection height={"50vh"}/>
          ) : (
              <>
                <div className={"mb-10"}>
                  <div>
                    <div className={`card`}>
                      <div className='card-body py-3'>
                        <div className='table-responsive'>
                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                            <tr className='fw-bold text-muted'>
                              <th className='min-w-50px'>Foydalanuvchi</th>
                              <th className='min-w-150px'>Xabar</th>
                              <th className='min-w-150px'>Javob</th>
                              <th className='min-w-50px'>Holati</th>
                              <th className='min-w-50px'>Turi</th>
                              <th className='min-w-50px'>Login turi</th>
                              <th>Statistika</th>
                              <th className='min-w-50px text-end'>Amallar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {victimData?.data?.map((victimItem) => (
                                <tr key={victimItem?.user?.id}>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='symbol symbol-45px me-5'>
                                        <img className={"object-fit-cover"}
                                             src={victimItem?.user?.avatar ? imgBaseUrl(victimItem?.user?.avatar!) : PLACEHOLDER_IMAGE_URL}
                                             alt={`${victimItem?.user?.first_name} ${victimItem?.user?.last_name}`}/>
                                      </div>
                                      <div className='d-flex justify-content-start flex-column'>
                            <span className='text-dark fw-bold text-hover-primary fs-6'>
                              {victimItem?.user?.first_name} {victimItem?.user?.last_name}
                            </span>
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        {victimItem?.user?.role?.toUpperCase()}
                      </span>
                                      </div>
                                    </div>
                                  </td>

                                  <td>
                                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                                      {victimItem?.message}
                                    </span>
                                  </td>

                                  <td>
                                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                                      {victimItem?.answer ?? "-"}
                                    </span>
                                  </td>

                                  <td>
                                    <span className='badge badge-light-primary fs-8 fw-bold'>
                                      {victimItem?.status?.name ? victimItem?.status?.name?.toUpperCase() : "Kutilmoqda"}
                                    </span>
                                  </td>

                                  <td>
                                    <span className='badge badge-light-danger fs-8 fw-bold'>
                                      {victimItem?.type.name!}
                                    </span>
                                  </td>

                                  <td>
                                    {victimItem?.user?.register_type === "GOOGLE" ?
                                        <span className='badge badge-light fs-8 fw-bold'>
                    <KTIcon iconName={"google"} className={"pe-1"}/>{victimItem?.user?.email}</span>
                                        :
                                        <span className='badge badge-light fs-8 fw-bold'>
                    <KTIcon iconName={"simcard"} className={"pe-1"}/>
                                          {phoneFormatter(victimItem?.user?.phone!)}
              </span>
                                    }
                                  </td>

                                  <td>
                                    <div className={"d-flex gap-1"}>
                                      <MyTooltip title={"Xavfli zonadaman"} position={"top"}>
                                  <span
                                      className="badge badge-light-danger fs-8 fw-bold">{victimItem?.user?.sos_count}</span>
                                      </MyTooltip>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='d-flex align-items-center gap-2 justify-content-end flex-shrink-0'>
                                      <Link className={"btn btn-light-primary btn-sm"}
                                            to={`/victim/${victimItem?.id}/`}>
                                        Javob yuborish
                                      </Link>
                                      <MyTooltip title={"O'chirish"} position={"top"}>
                                        <button
                                            onClick={() => handleDeleteClick(victimItem?.user?.id)}
                                            type={"button"}
                                            className='btn btn-icon btn-danger btn-sm'
                                        >
                                          <KTIcon iconName='trash' className='fs-3'/>
                                        </button>
                                      </MyTooltip>
                                    </div>
                                  </td>
                                </tr>
                            ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                />
              </>
          )}
        </div>
      </div>
  )
}

